export default "__VITE_ASSET__DABZF$WX__"